module.exports = __webpack_public_path__ + "img/lioness.0d4ca4c8.jpg";